import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import constants from '../../common/theme/constants';
import ThemeColors from '../../common/theme/colors';

const { fontWeight, spacing } = constants;

export const StyledLabel = styled.label`
  display: block;
  margin-left: ${spacing.absolute.s}px;
  color: ${ThemeColors.gray_50};
  margin-bottom: 0;
  line-height: 1;
  font-size: ${constants.fontSize.text_14}rem;
  padding: ${spacing.absolute.xs}px 0 ${spacing.absolute.xxs}px 0;
`;

export const StyledDiv = styled.div`
  margin-left: ${spacing.absolute.s}px;
  margin-bottom: ${spacing.absolute.s}px;
  font-weight: ${fontWeight.bold};
  padding-top: ${spacing.absolute.xxs}px;
  padding-bottom: ${spacing.absolute.sm}px;
`;

interface FieldProps {
  field: string;
  label: string;
  value: string | number;
  hideLabels?: boolean;
  labelComponent?: FunctionComponent;
  valueComponent?: FunctionComponent;
}

const Field = ({
  field,
  label,
  value,
  hideLabels = false,
  labelComponent,
  valueComponent,
}: FieldProps) => {
  const LabelComponent = labelComponent || StyledLabel;
  const ValueComponent = valueComponent || StyledDiv;
  if (hideLabels) {
    return (
      <div key={field}>
        <ValueComponent key={`div_${field}`} data-qa-id={field}>
          {value || value === 0 ? value : '-'}
        </ValueComponent>
      </div>
    );
  }
  return (
    <div key={field}>
      <LabelComponent key={`label_${field}`}>{label}</LabelComponent>
      <ValueComponent key={`div_${field}`} data-qa-id={field}>
        {value || value === 0 ? value : '-'}
      </ValueComponent>
    </div>
  );
};

export default Field;
